<template>
  <Card :title="$t('pipelines.changeStep')" containerClass="mb-5" v-if="selectedCriterias?.length > 0">
    <div class="row px-10 py-5">
      <OutlineButton  :border="false" :color="primaryColor" btn-text="pipelines.criteriasCheck" @click="openCriteriasModal" />
    </div>
  </Card>
  <SetOpportunityCriteriasModal id="kt_validate_criterias" @load="reload" :opportunity="currentOpportunity" :step="stepToValidate" :selected="selectedCriterias"/>

</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import OutlineButton from "@/components/OutlineButton.vue"
import {computed, onMounted, ref, watch} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import Select2 from "@/components/Select2.vue"
import UserFormModal from "@/components/modals/UserForm.vue"
import RequiredText from "@/components/RequiredText.vue"
import abilities from "@/composables/abilities";
import SetOpportunityCriteriasModal from "./criterias/SetOpportunityCriteriasModal.vue";

const store = useStore()
const route = useRoute()

const secondaryColor = ref('rgba(240, 120, 23, 1)')
const primaryColor = ref('rgba(0, 114, 206, 1)')

const emits = defineEmits(['load', 'loadUsers'])

const props = defineProps({pipeline: Object})

const currentOpportunity = ref('')
const stepToValidate = ref('')
const selectedCriterias = ref([])


watch(() => props.pipeline, (value) => {
  currentOpportunity.value = props.pipeline?.id
  stepToValidate.value = props.pipeline?.opportunityState?.id
  selectedCriterias.value = props.pipeline?.criterias
})

function openCriteriasModal(){
  $('#kt_validate_criterias').modal('toggle')
}

function reload(){
  emits('load')
}
</script>

<style scoped>
</style>
